import styled from 'styled-components'
import { Box } from 'src/components'

export const OverContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`
export const SectionContact = styled(Box)`
    display: flex;
    width: 100%;
    z-index: 10;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background: ${({ theme }) => theme.colors.lineaGradiant};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
        flex-direction: row;
    }
`

export const SectionContactLimit = styled(Box)`
    display: flex;
    width: 100%;
    z-index: 10;
    height: 100%;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1380px;
        flex-direction: row;
    }
`
export const ContentSubscribe = styled(Box)`
    display: flex;
    width: 100%;
    z-index: 10;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 60%;
        flex-direction: row;
    }
`
export const ContentSubscribeTitle = styled(Box)`
    display: flex;
    width: 100%;
    height: 100%;
    z-index: 10;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 40%;
        flex-direction: row;
    }
`
export const SectionInformation = styled(Box)`
    display: flex;
    width: 100%;
    flex-direction: column;
    position: relative;
    z-index: 10;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        flex-direction: row;
        justify-content: start;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1280px;
        flex-direction: row;
    }
`
export const SectionInformationOver = styled(Box)`
    display: flex;
    width: 100%;
    flex-direction: column;
    position: relative;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.footerPrimary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionInformationSection = styled(Box)`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-wrap: nowrap;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
    }
`
export const SectionInformationSubscribe = styled(Box)`
    display: flex;
    width: 90%;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 30%;
    }
`
export const WaveContainer = styled.div`
    position: absolute;
    width: 100%;
    z-index: 1;
    top: 0;
    margin-top: -3rem;
`

export const FormSection = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-left: 10px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        margin-top: 10px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        justify-content: start;
        margin-top: 0;
        margin-left: 0;
        flex-direction: row;
        align-items: start;
    }
`
export const ContentFormik = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: end;
    align-items: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: row;
    }
`
export const ContentImput = styled(Box)`
    width: 90%;
    height: 50px;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    align-items: center;
`
export const ContentData = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

export const ContentButton = styled.button`
    min-width: 78px;
    height: 90%;
    background: ${({ theme }) => theme.colors.second};
    color: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.second};
    padding: 0 10px;
    position: absolute;
    z-index: 1;
    right: 5px;
    overflow: hidden;
    display: inline-block;
    border-radius: 12px;
    :hover {
        color: ${({ theme }) => theme.colors.dark};
        border: 2px solid ${({ theme }) => theme.colors.white};
    }
    :after {
        content: '';
        color: ${({ theme }) => theme.colors.dark};
        background: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.white};
        position: absolute;
        z-index: -1;
        padding: 16px 20px;
        display: block;
        border-radius: 50%;
        left: -50%;
        right: -50%;
        top: -150%;
        bottom: -150%;
        transform: scale(0, 0);
        transition: all 0.4s ease;
    }
    :hover::after {
        transition: all 0.6s ease-out;
        transform: scale(1, 1);
    }
`
export const ContentFinishFooter = styled(Box)`
    border-top: 2px solid ${({ theme }) => theme.colors.grey};
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: start;
    background: ${({ theme }) => theme.colors.footerPrimary};
`
export const ContentIconSocial = styled(Box)`
    min-width: 350px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        min-width: 400px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
